module.exports = __webpack_public_path__ + "h5/img/team_img.68e0e9d5.png";